<script setup>
import {ref} from "vue";
import useGrid from "@/composables/useGrid";
import startupsService from "@/services/startups.service";
import TablePager from "@/components/TablePager.vue";
import {useStore} from "vue2-helpers/vuex";
import {getNoun} from "../../helpers/string";

const {startupId, startupName} = defineProps(['startupId', 'startupName']);
const store = useStore();

const {gridParams, gridMethods, items} = useGrid(getData, 6);
const showModal = ref(false);
const corporate = ref(null);

async function getData(pageParams) {
    return startupsService.getPartnershipsIndex(startupId, corporate.value.id, pageParams);
}

function getGroupedItems(items) {
    const groups = {};
    const groupsData = {};

    items.forEach(partnership => {
        const group = partnership.sector_id + '-' + partnership.subsector_id;
        groupsData[group] = {
            sectorId: partnership.sector_id,
            subsectorId: partnership.subsector_id,
            sectorName: partnership.sector_name,
            subsectorName: partnership.subsector_name
        };

        if (!groups[group]) {
            groups[group] = [];
        }
        groups[group].push(partnership);
    });

    const groupedItems = [];

    for (const group in groups) {
        groupedItems.push({
            ...groupsData[group],
            partnerships: groups[group]
        });
    }

    return groupedItems;
}

function open(corporateData) {
    corporate.value = corporateData;
    gridMethods.resetList();
    showModal.value = true;
}

defineExpose({
    open
});
</script>

<template>
    <b-modal v-model="showModal" hide-footer :title="`${startupName}'s Partnerships With ${corporate?.name}`" modal-class="modal-w-md modal-blue modal-partner-with">
        <template v-if="items.length">
            <p class="modal-partner-with__qty">{{gridParams.totalRowsCount}} {{getNoun('Partnership', gridParams.totalRowsCount)}}</p>

            <div v-for="(group, index) in getGroupedItems(items)" :key="index">

                <template v-if="store.getters.settings.enable_market_tool">
                    <div class="modal-partner-with__card-title">
                        <div>
                            <a class="link" :href="`/markets?sector_id=${group.sectorId}`" target="_blank">{{group.sectorName}}</a>
                            <span class="modal-partner-with__card-title__connector"></span><a class="link" :href="`/markets?cluster_id=${group.subsectorId}`" target="_blank">{{group.subsectorName}}</a>
                        </div>
                    </div>
                </template>

                <template v-else>
                    <div class="modal-partner-with__card-title">
                        <div>
                            {{group.sectorName}} 
                            <span class="modal-partner-with__card-title__connector"></span> 
                            {{group.subsectorName}}
                        </div>
                    </div>
                </template>

                <div class="modal-partner-with__card">
                    <div v-for="partnership in group.partnerships" :key="partnership.id" class="modal-partner-with__card__item">
                        <b>{{partnership.partnership_year}}:</b>
                        <p>{{partnership.summary}}</p>
                    </div>
                </div>
            </div>

            <TablePager
                v-if="items.length"
                :pages-count="gridParams.pagesCount"
                :init-page="gridParams.currentPage"
                @changePage="gridMethods.changePage"
            />
        </template>
    </b-modal>
</template>

<style scoped>

</style>
